// extracted by mini-css-extract-plugin
module.exports = {"recaptchaMessage":"styles_recaptchaMessage__rCwH0","addNewCard":"styles_addNewCard__HkPa7"};